import { render, staticRenderFns } from "./google_food_location_modal.vue?vue&type=template&id=18a1f5bb&scoped=true&"
import script from "./google_food_location_modal.vue?vue&type=script&lang=js&"
export * from "./google_food_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1f5bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a1f5bb')) {
      api.createRecord('18a1f5bb', component.options)
    } else {
      api.reload('18a1f5bb', component.options)
    }
    module.hot.accept("./google_food_location_modal.vue?vue&type=template&id=18a1f5bb&scoped=true&", function () {
      api.rerender('18a1f5bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/google_food/location/google_food_location_modal.vue"
export default component.exports